module.exports = __webpack_public_path__ + "assets/img/projectsvg.dfb957dc.svg";